import { useMemo } from "react";
import LayerIcon from "../../../Icons/LayerIcon";
import { Tooltip } from "../../../UI";
import {
  StyledFilterHeader,
  StyledFilterSection,
  StyledLayersContainer,
} from "../MobileFilter-styled";
const FilterSection = ({
  config,
  t,
  title,
  children,
  layerTitle,
  fieldsLayers,
}) => {
  const fillColor = "#706f6f"; //"var(--fontColor)";
  const circleColor = "transparent";
  const seenTitles = new Set();

  const uniqueLayers = useMemo(() => {
    const uniqueArray = [];
    fieldsLayers.forEach((layer) => {
      const title = layer.getLayerTitle(t);
      if (!seenTitles.has(title)) {
        seenTitles.add(title);
        uniqueArray.push(layer);
      }
    });

    return uniqueArray;
  }, [fieldsLayers, t]);

  return (
    <StyledFilterSection>
      <StyledFilterHeader>
        <StyledLayersContainer>
          {uniqueLayers.map((layer) => (
            <Tooltip
              showOnHover
              key={layer.id}
              placement="top"
              content={layer.getLayerTitle(t)}
              wrapperStyles={{
                zIndex: 20,
              }}
              zIndex={21}
              blurred
            >
              <LayerIcon
                config={config}
                t={t}
                fill={fillColor}
                opsColor={fillColor}
                width={22}
                height={22}
                circleColor={circleColor}
                wrapperStyles={{
                  borderRadius: "100px",
                  background: circleColor,
                  width: "22px",
                  height: "22px",
                  minWidth: "22px",
                }}
                textStyles={{
                  width: "22px",
                  height: "22px",
                  minWidth: "22px",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  textAlign: "center",
                  color: fillColor,
                  borderRadius: "100px",
                  background: circleColor,
                  border: "1px solid #eee",
                }}
                layer={layer}
                defaultTitle={layer.getLayerTitle(t)}
              />
            </Tooltip>
          ))}
        </StyledLayersContainer>
        <span>
          {title}
          {layerTitle && <span className="filters-length">{layerTitle}</span>}
        </span>
      </StyledFilterHeader>
      <div
        style={{
          display: "grid",
          gridTemplateRows: "1fr",
          transition: "all 0.5s",
          gap: 4,
          overflow: "hidden",
        }}
      >
        <div>{children}</div>
      </div>
    </StyledFilterSection>
  );
};

export default FilterSection;
